import { defineComponent as _defineComponent } from 'vue'
import { twMerge } from 'tailwind-merge'


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSubtitle',
  props: {
    twClass: null
  },
  setup(__props: any) {



return { __sfc: true,twMerge }
}

})